module.exports = __webpack_public_path__ + "img/fk.dd7bc35.svg";